import React, { useState } from "react";
import Select from 'react-select';
import { IconButton, Box } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import VisibilityIcon from '@mui/icons-material/Visibility';
import '../styles/responsive.css';

function ProdutoTabela({ vetor, selecionarProduto, exibirFichaTecnica, filtrarNomeModelo, filtrarMarca, vetrores,setModoCopia }) {

    const [nomeModelo, setNomeModelo] = useState("");
    const [marca, setMarca] = useState("");

    // apenas produtos 'pai' devem aparecer na listagem/filters
    const filterParents = (list) => Array.isArray(list) ? list.filter(p => {
        // detect common parent id fields; se existir, é uma variação (filho)
        return !(p.parentProductId || p.parentId || p.parentProduto || p.parent || p.parent_product_id);
    }) : [];

    const vetroresPais = filterParents(vetrores);

    const optionsNomeModelo = Array.from(
        new Set(vetroresPais.map((obj) => obj.nomeModelo))
    ).map((nome) => ({
        value: nome,
        label: nome,
    }));
    

    const optionsMarca = Array.from(
        new Set(vetroresPais.map((obj) => obj.marca))
    ).map((marca) => ({
        value: marca,
        label: marca,
    }));

    const handleSelectNomeModelo = (selectedOption) => {
        setNomeModelo(selectedOption ? selectedOption.value : "");
    };

    const handleSelectMarca = (selectedOption) => {
        setMarca(selectedOption ? selectedOption.value : "");
    };

    const handleBuscar = () => {
        if (!nomeModelo && !marca) {
            // Se os campos estiverem vazios, chame as funções de filtro sem argumentos ou com valores padrão
            filtrarNomeModelo(null);
            filtrarMarca(null);
        } else {
            if (nomeModelo) filtrarNomeModelo(nomeModelo);
            if (marca) filtrarMarca(marca);
        }
    };

    // const [filtroNome, setFiltroNome] = useState("")
    // const [filtroMarca, setFiltroMarca] = useState("")

    // const produtosFiltrados = vetor.filter((produto) => 
    //     produto.nomeModelo.toLowerCase().includes(filtroNome.toLowerCase()) &&
    //     produto.nomeMarca.toLowerCase().includes(filtroMarca.toLowerCase())
    // );
    // const [produtoSelecionado, setProdutoSelecionado] = useState('');
    // const [exibirSelect, setExibirSelect] = useState(false);

    const handleCopiarFicha = (idProduto) => {
        selecionarProduto(idProduto);
        setModoCopia(true); // Ativa o modo de cópia
    }
    return (
        <div>
            <Box className="search-container" sx={{ mb: 2 }}>
                <Select
                    value={optionsNomeModelo.find(option => option.value === nomeModelo) || null}
                    onChange={handleSelectNomeModelo}
                    options={optionsNomeModelo}
                    isClearable={true}
                    isSearchable={true}
                    placeholder="Pesquisa Nome Modelo"
                    className="fixed-select"
                />

                <Select
                    value={optionsMarca.find(option => option.value === marca) || null}
                    onChange={handleSelectMarca}
                    options={optionsMarca}
                    isClearable={true}
                    isSearchable={true}
                    placeholder="Pesquisa Marca"
                    className="fixed-select"
                />
                <button
                    onClick={handleBuscar}
                    className="btn btn-primary btn-sm"
                >
                    Busca
                </button>
            </Box>

            <div className="table-responsive-container">
                <table className="table table-responsive table-mobile table-compact">
                    <thead>
                        <tr>
                            <th className="col-imagem">Imagem</th>
                            <th className="col-nome">Nome Modelo</th>
                            <th>Cor</th>
                            <th>Marca</th>
                            <th>Referência</th>
                            <th>Status</th>
                            <th>Copiar Itens</th>
                            <th>Ficha Técnica</th>
                            <th>Ações</th>
                        </tr>
                    </thead>
                    <tbody>
                        {Array.isArray(vetor) && vetor.length > 0 ? (
                            // mostrar apenas produtos pai na tabela
                            filterParents(vetor).map((produto, indice) => (
                                <tr key={produto.idProduto}>
                                    <td className="col-imagem" data-label="Imagem" style={{overflow:'hidden'}}>
                                        {(() => {
                                            const raw = produto && produto.image ? String(produto.image) : '';
                                            const src = raw
                                                ? (raw.startsWith('http') || raw.startsWith('data:')
                                                    ? raw
                                                    : `data:image/jpeg;base64,${raw}`)
                                                : '';
                                            return (
                                                <img
                                                    src={src || ''}
                                                    alt={`Imagem do produto ${produto.nomeModelo || ''}`}
                                                    className="product-image"
                                                    style={{
                                                        width: '150px',
                                                        height: '100px',
                                                        border: '1px solid #ccc',
                                                        borderRadius: '9px',
                                                        backgroundColor: '#fff',
                                                        objectFit: 'contain',
                                                        display: src ? 'block' : 'none'
                                                    }}
                                                    onError={(e)=>{ e.currentTarget.style.display='none'; }}
                                                />
                                            );
                                        })()}
                                        {(!produto?.image || !String(produto.image)) && (
                                            <div style={{
                                                width: '150px', height: '100px', border: '1px dashed #ccc', borderRadius: '9px',
                                                display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#999', fontSize: 12, background: '#fafafa'
                                            }}>
                                                Sem imagem
                                            </div>
                                        )}
                                    </td>
                                    <td className="col-nome text-ellipsis" title={produto.nomeModelo} data-label="Nome Modelo">{produto.nomeModelo}</td>
                                    <td data-label="Cor">{produto.cor}</td>
                                    <td data-label="Marca">{produto.marca}</td>
                                    <td data-label="Referência">{produto.referencia}</td>
                                    <td data-label="Status">{produto.status}</td>
                                    <td data-label="Copiar Itens">
                                        <button
                                            onClick={() => {
                                                handleCopiarFicha(produto.idProduto);
                                                setModoCopia(true);
                                            }}
                                            className="btn btn-secondary btn-sm"
                                        >
                                            Copiar Ficha Técnica
                                        </button>
                                    </td>
                                    <td data-label="Ficha Técnica">
                                        <IconButton
                                            size="small"
                                            onClick={() => {
                                                console.log('Produto clicado:', produto);
                                                console.log('idProduto passado:', produto.idProduto);
                                                exibirFichaTecnica(produto.idProduto);
                                            }}
                                            color="primary"
                                        >
                                            <VisibilityIcon />
                                        </IconButton>
                                    </td>
                                    <td data-label="Ações">
                                        <IconButton
                                            size="small"
                                            onClick={() => selecionarProduto(produto.idProduto)}
                                            color="primary"
                                        >
                                            <EditIcon />
                                        </IconButton>
                                    </td>
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan="9" style={{ textAlign: 'center' }}>
                                    Nenhum produto encontrado.
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default ProdutoTabela;